// ** React Imports
import { Navigate, Outlet, useLocation } from 'react-router-dom'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'

// ** Utils
import { useEffect, useState } from 'react'

import { getUserName, isMfgEmployee } from '../auth/LoginUser'
import { ToastMessageError } from '../components/common/ToastMessage'
import { fetchUserGroup, hasExactUserGroup } from '../components/react-select/fetchUserGroup'
import { useSearchEmployeeByEmployeeCode } from '../utility/hooks/react-query/useEmployeeData'
import { useGetMergeMenu } from '../utility/hooks/react-query/useGetMergeMenu'

const MFG_M75_MENU_IDS = [612, 613, 614, 615]
const HOME_PATH = '/home/detail/1'

const getMenuNavLinks = (menuItems) =>
  menuItems.reduce((navLinks, menuItem) => {
    if (menuItem.navLink) navLinks.push(menuItem.navLink)
    if (menuItem.children) navLinks.push(...getMenuNavLinks(menuItem.children))

    return navLinks
  }, [])

const normalizePath = (path) => {
  if (!path || path === '/') return path

  return path.replace(/\/+$/, '')
}

const ALL_MENU_NAV_LINKS = getMenuNavLinks(navigation).map(normalizePath)

// ** Function

const getUrlParamSearch = (userGroup) => {
  // let params = ``;
  // params += `"APPLICATION_NAME": "${process.env.REACT_APP_BASENAME}"`;
  // params += `, "USER_NAME":"${getUserName()}"`;
  // params += `, "USER_GROUP_NAME":"${userGroup || getUserGroupName()}"`;
  // params = `{${params}}`;
  // return params;

  const dataItem = {
    APPLICATION_ID: process.env.REACT_APP_APPLICATION_ID,
    USER_NAME: getUserName()
    // USER_GROUP_NAME: userGroup || getUserGroupName(),
  }

  return dataItem
}

const VerticalLayout = (props) => {
  // console.log("verticalLayout");

  const [menuData, setMenuData] = useState([])
  const [isFetchData, setIsFetchData] = useState(true)
  const [userGroup, setUserGroup] = useState(null)
  const [menuLayout, setMenuLayout] = useState([])
  const [menuPermission, setMenuPermission] = useState([])
  const [user, setUser] = useState({})
  const [hasRequiredMfgM75Groups, setHasRequiredMfgM75Groups] = useState(false)

  const location = useLocation()

  useEffect(() => {
    let isActive = true

    const checkMfgM75Groups = async () => {
      try {
        const [mfgGroups, approverGroups] = await Promise.all([
          fetchUserGroup('MFG'),
          fetchUserGroup('Approver')
        ])

        if (isActive) {
          setHasRequiredMfgM75Groups(
            hasExactUserGroup(mfgGroups, 'MFG') && hasExactUserGroup(approverGroups, 'Approver')
          )
        }
      } catch (error) {
        if (isActive) setHasRequiredMfgM75Groups(false)
      }
    }

    checkMfgM75Groups()

    return () => {
      isActive = false
    }
  }, [])

  // useEffect(() => {
  //   if (!getUserName()) {
  //     // navigate("/login");
  //     ToastMessageWarning({ message: "You are not logging in. Please login" });
  //     navigate("/login");
  //     return;
  //   }
  // }, [location]);

  // console.log(location.pathname);
  // if (location.pathname == '/') {
  //   navigate('/leave-request');
  // }

  let menu = []

  const onSuccessSearchData = (data) => {
    // console.log(data);
    // console.log("search menu");
    setIsFetchData(false)
    if (data.data.Status == true && data.data.ResultOnDb.length > 0) {
      setMenuLayout(navigation)
      setMenuPermission(data.data.ResultOnDb)
    } else if (data.data.Status == true && data.data.ResultOnDb.length === 0) {
      setMenuLayout(navigation)
      setMenuPermission(data.data.ResultOnDb)

      menu = navigation.filter((elem) => {
        return elem.meta?.publicGroup
      })

      const message = {
        title: 'Search GetMenu',
        message: 'Your user group do not have permission to see the another menu.'
      }

      // ToastMessageWarning(message);

      // console.log("verticalLayout");

      // navigate("/auth/not-auth");
    }
  }

  const onErrorSearchData = (error) => {
    setIsFetchData(false)

    setMenuLayout(navigation)
    setMenuPermission([])

    const message = {
      title: 'Search GetMenu',
      message: error.message
    }
    ToastMessageError(message)
  }

  // const { isLoading, error, data, isSuccess, isFetching } = useGetMenu(
  //   onSuccessSearchData,
  //   onErrorSearchData,
  //   getUrlParamSearch(userGroup),
  //   isFetchData
  // );

  const { isLoading, error, data, isSuccess, isFetching } = useGetMergeMenu(
    onSuccessSearchData,
    onErrorSearchData,
    getUrlParamSearch(userGroup),
    isFetchData
  )

  const onSuccessSearchDataEmployee = (data) => {
    setIsFetchData(false)
    if (data.data.Status == true && data.data.ResultOnDb.length > 0) {
      const dataItems = JSON.parse(localStorage.getItem('userData'))
      let dataUser = data.data.ResultOnDb[0]
      dataUser = { ...dataUser, ...dataItems }
      setUser(data.data.ResultOnDb)
      localStorage.setItem('userData', JSON.stringify(dataUser))
    } else if (data.data.Status == true && data.data.ResultOnDb.length === 0) {
      setUser(data.data.ResultOnDb)
    }
  }

  const onErrorSearchDataEmployee = (error) => {
    setIsFetchData(false)
    setUser([])

    const message = {
      title: 'Search Employee',
      message: error.message
    }
    ToastMessageError(message)
  }

  const {
    isLoading: isLoadingEmployee,
    error: errorEMployee,
    data: dataEmployee,
    isSuccess: isSuccessEmployee,
    isFetching: isFetchingEmployee
  } = useSearchEmployeeByEmployeeCode(
    onSuccessSearchDataEmployee,
    onErrorSearchDataEmployee,
    {
      EMPLOYEE_CODE: getUserName()
    },
    true
  )

  // useEffect(() => {
  //   const username = getUserName();

  //   if (!username) {
  //     navigate("/login");
  //   }
  // }, []);

  if (isLoading) {
    return (
      <Layout menuData={[]} {...props}>
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      </Layout>
    )
  }

  const hasMfgM75FullMenuAccess = isMfgEmployee() && hasRequiredMfgM75Groups
  const effectiveMenuPermission = hasMfgM75FullMenuAccess
    ? [
        ...menuPermission,
        ...MFG_M75_MENU_IDS.filter(
          (menuId) => !menuPermission.some((permission) => Number(permission.id) === menuId)
        ).map((menuId) => ({ id: menuId }))
      ]
    : menuPermission

  // Function Get Menu Intersection
  const getMenuIntersection = (Obj1, Obj2) => {
    return Obj1.filter((item1) => Obj2.some((item2) => Number(item1.id) === Number(item2.id)))
  }

  const GetMenu = (element) => {
    let elements = []
    let menuInside = []

    if (element.header) {
      if (element.header !== 'undefined') {
        menu.push(element)
      }
    }

    for (let idx = 0; idx < effectiveMenuPermission.length; idx++) {
      const elementCompare = effectiveMenuPermission[idx]

      if (elementCompare.id == element.id) {
        if (elementCompare.children && element.children) {
          elements = getMenuIntersection(element.children, elementCompare.children)
          element.children = elements
          menuInside.push(element)
        } else {
          menu.push(element)
        }
      }
    }

    if (menuInside.length > 0) {
      menu.push(element)
    }
  }

  // Set default home menu
  for (let i = 0; i < 1; i++) {
    const element = menuLayout[i]
    menu.push(element)
  }

  // Menu application from Permission setting
  for (let i = 1; i < menuLayout.length; i++) {
    const element = menuLayout[i]

    if (element) {
      if (element.header === 'undefined') {
        continue
      }
      GetMenu(element)
    }
  }

  const removeMenu = (i) => {
    menu.splice(i, 1)
  }

  for (let i = 0; i < menu.length; i++) {
    if (menu[i]?.header) {
      const nextItem = menu[i + 1]

      // ถ้าถัดไปเป็น header หรือไม่มีอะไรต่อ = header เปล่า
      if (!nextItem || nextItem?.header) {
        removeMenu(i)
        i-- // ลด index
      }
    }
  }

  if (menu[menu.length - 1]?.header !== undefined) menu.pop()

  const positionCode = dataEmployee?.data?.ResultOnDb?.[0]?.EMPLOYEE_POSITION_CODE[0]
  // console.log(positionCode);
  // const positionCode = "W";

  if (!(positionCode === 'S' || positionCode === 'E' || positionCode === 'M')) {
    // console.log(menu);
    menu = menu.filter((item) => {
      if (item?.header) {
        if (item.header.split(' ').some((e) => e === 'Flex')) {
          // console.log(item);
          // poodit
          return false
          // return true;
        }
      }
      if (item?.title) {
        if (item.title.split(' ').some((e) => e === 'Flex')) {
          // console.log(item);
          // poodit
          return false
          // return true;
        }
      }

      return true
    })
  }

  const rawMenuPermission = data?.data?.ResultOnDbRawData || []
  const effectiveRawMenuPermission = hasMfgM75FullMenuAccess
    ? [
        ...rawMenuPermission,
        ...MFG_M75_MENU_IDS.filter(
          (menuId) => !rawMenuPermission.some((permission) => Number(permission.MENU_ID) === menuId)
        ).map((menuId) => ({ MENU_ID: menuId }))
      ]
    : rawMenuPermission

  localStorage.setItem('menu', JSON.stringify(effectiveRawMenuPermission))

  const currentPath = normalizePath(location.pathname)
  const isMenuPath = ALL_MENU_NAV_LINKS.includes(currentPath)
  const canAccessCurrentMenuPath = getMenuNavLinks(menu).map(normalizePath).includes(currentPath)

  if (isMenuPath && !canAccessCurrentMenuPath) {
    return <Navigate replace to={HOME_PATH} />
  }

  return (
    <>
      <Layout
        menuData={menu}
        {...props}
        userGroup={userGroup}
        setUserGroup={setUserGroup}
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
      >
        <Outlet />
      </Layout>
    </>
  )
}

export default VerticalLayout
